import i18next from 'i18next'
import React from 'react'
import { cookiebarClasses, cookiePlaceholderClasses } from '../../utils/style'
import { FormControls } from '../../utils/forms'
import { Link } from '../../utils/links'
import { getClassName } from '../../utils/utils'
import { SVGIconProps } from '../cmsPage/blocks/blocksState'
import { datalayerHandler } from '../../utils/datalayer'
import { Accepted, Cookie, requiredCookies } from '../../utils/cookies'

export type CookiePlaceholderStyle = Partial<{
  cookiesClassName: string
  cookiesInnerClassName: string
  cookiesTextClassName: string
  cookiesClickableClassName: string
  cookiesClickableLabelClassName: string
  cookiesClickableIconClassName: string
  iconId: string
}>

export type CookiebarStyle = Partial<{
  cookiebarClassName: string
  cookiebarOuterClassName: string
  cookiebarInnerClassName: string
  cookiebarTextClassName: string
  cookiebarTitleClassName: string
  cookiebarIntroClassName: string
  cookiebarFooterClassName: string
  cookiebarClickableWrapperClassName: string
  cookiebarClickablePrimaryClassName: string
  cookiebarClickableSecondaryClassName: string
  cookiebarClickableLabelClassName: string
  cookiebarClickableIconClassName: string
  iconId: string
  cookiebarFormClassName: string
  cookiebarFormListClassName: string
  cookiebarFormItemClassName: string
  cookiebarExpandClassName: string
  cookiebarExpandLabelClassName: string
  cookiebarExpandIconClassName: string
  expandIconId: string
}>

export const CookiePlaceholderLayout = (props: { onAccept: () => void }) => {
  const { onAccept } = props
  return (
    <div className={getClassName(cookiePlaceholderClasses, 'cookiesClassName', 'text-center bg-light')}>
      <div className={getClassName(cookiePlaceholderClasses, 'cookiesInnerClassName', 'py-5')}>
        <div className={getClassName(cookiePlaceholderClasses, 'cookiesTextClassName', '')}>
          {i18next.t('cookies:cookiePlaceholderText')}{' '}
          <Link url='/cookie-verklaring'>
            {i18next.t('cookies:cookiePlaceholderLinkLabel')}
          </Link>
          .
        </div>
        <button
          className={getClassName(cookiePlaceholderClasses, 'cookiesClickableClassName', 'btn btn-dark')}
          onClick={() => {
            datalayerHandler('cookies', 'accepted', 'cookies');
            onAccept();
          }}
        >
          <span className={getClassName(cookiePlaceholderClasses, 'cookiesClickableLabelClassName', '')}>
            {i18next.t('cookies:cookiebarAcceptCookies')}
          </span>
          {/* {SVGIcon && (
            <svg
              className={getClassName(
                options,
                'cookiesClickableIconClassName',
                'ml-3'
              )}
              aria-hidden="true"
              width={SVGIcon.width ? SVGIcon.width : '24px'}
              height={SVGIcon.height ? SVGIcon.height : '24px'}
            >
              <use
                xlinkHref={getClassName(
                  options,
                  'iconId',
                  '#icon--chevron-right-large'
                )}
              />
            </svg>
          )} */}
        </button>
      </div>
    </div>
  )
}

export const CookiebarLayout = (props: {
  showOptions: boolean
  toggleOptions: () => void
  onAcceptAll: () => void
  onDeclineAll: () => void
  onApplySettings: () => void
  onSetSingle: (cookie: Cookie, state: Accepted) => void
  cookieValues: Map<Cookie, Accepted>
  svgIcon?: SVGIconProps
  expandSVGIcon?: SVGIconProps
}) => {
  const {
    showOptions,
    toggleOptions,
    onAcceptAll,
    onDeclineAll,
    onApplySettings,
    cookieValues,
    onSetSingle,
    svgIcon,
    expandSVGIcon,
  } = props

  return (
    <section
      id="cookiebar"
      className={getClassName(cookiebarClasses, 'cookiebarClassName', 'text-center bg-light')}
      role="alert"
      aria-labelledby="a11y-cookiebar-title"
    >
      <div className={getClassName(cookiebarClasses, 'cookiebarOuterClassName', 'py-5')}>
        <div className={getClassName(cookiebarClasses, 'cookiebarInnerClassName', '')}>
          <div className={getClassName(cookiebarClasses, 'cookiebarTextClassName', '')}>
            <h2 id="a11y-cookiebar-title" className={getClassName(cookiebarClasses, 'cookiebarTitleClassName', 'h3')}>
              {i18next.t('cookies:cookiebarTitle', {
                siteName: 'Evofenedex',
              })}
            </h2>
            <div
              className={getClassName(cookiebarClasses, 'cookiebarIntroClassName', '')}
              dangerouslySetInnerHTML={{
                __html: `${i18next.t('cookies:cookiebarIntro')}`,
              }}
            />
          </div>
          <div className={getClassName(cookiebarClasses, 'cookiebarFooterClassName', '')}>
            <div className={getClassName(cookiebarClasses, 'cookiebarClickableWrapperClassName', '')}>
              <button
                className={getClassName(cookiebarClasses, 'cookiebarClickablePrimaryClassName', 'btn btn-dark')}
                onClick={() => {
                  datalayerHandler('cookies', 'accepted', 'cookies');
                  onAcceptAll();
                }}
              >
                <span className={getClassName(cookiebarClasses, 'cookiebarClickableLabelClassName', '')}>
                  {i18next.t('cookies:cookiebarAcceptCookies')}
                </span>
                {/* {SVGIcon && (
                  <svg
                    className={getClassName(
                      options,
                      'cookiebarClickableIconClassName',
                      'ml-3'
                    )}
                    aria-hidden="true"
                    width={SVGIcon.width ? SVGIcon.width : '24px'}
                    height={SVGIcon.height ? SVGIcon.height : '24px'}
                  >
                    <use
                      xlinkHref={getClassName(
                        options,
                        'iconId',
                        '#icon--chevron-down'
                      )}
                    />
                  </svg>
                )} */}
              </button>
            </div>
            <div className={getClassName(cookiebarClasses, 'cookiebarClickableWrapperClassName', '')}>
              <button
                className={getClassName(cookiebarClasses, 'cookiebarClickableSecondaryClassName', 'btn btn-dark')}
                onClick={() => {
                  onDeclineAll();
                  datalayerHandler('cookies', 'declined', 'cookies');
                }}
              >
                <span className={getClassName(cookiebarClasses, 'cookiebarClickableLabelClassName', '')}>
                  {i18next.t('cookies:cookiebarDeclineCookies')}
                </span>
                {/* {SVGIcon && (
                  <svg
                    className={getClassName(
                      options,
                      'cookiebarClickableIconClassName',
                      'ml-3'
                    )}
                    aria-hidden="true"
                    width={SVGIcon.width ? SVGIcon.width : '24px'}
                    height={SVGIcon.height ? SVGIcon.height : '24px'}
                  >
                    <use
                      xlinkHref={getClassName(
                        options,
                        'iconId',
                        '#icon--chevron-right-large'
                      )}
                    />
                  </svg>
                )} */}
              </button>
            </div>
          </div>

          <div className={getClassName(cookiebarClasses, 'cookiebarFormClassName', '')}>
            {/* Expand button */}
            <button
              className={getClassName(cookiebarClasses, 'cookiebarExpandClassName', 'btn btn-dark')}
              onClick={toggleOptions}
              aria-controls="a11y-cookiebar-toggle"
              aria-expanded={showOptions}
            >
              <span className={getClassName(cookiebarClasses, 'cookiebarExpandLabelClassName', '')}>
                {i18next.t('cookies:cookiebarShowOptions')}
              </span>
              {expandSVGIcon && (
                <svg
                  className={getClassName(cookiebarClasses, 'cookiebarExpandIconClassName', 'ml-3')}
                  aria-hidden="true"
                  width={expandSVGIcon.width ? expandSVGIcon.width : '24px'}
                  height={expandSVGIcon.height ? expandSVGIcon.height : '24px'}
                >
                  <use xlinkHref={getClassName(cookiebarClasses, 'expandIconId', '#icon--chevron-down')} />
                </svg>
              )}
            </button>

            {/* Expand options */}
            <div
              id="a11y-cookiebar-toggle"
              aria-hidden={!showOptions}
              className={getClassName(cookiebarClasses, 'cookiebarFormListClassName', '')}
            >
              <ul>
                {Array.from(cookieValues).map((cookieValue) => {
                  const cookie = cookieValue[0]
                  const isAccepted = cookieValue[1]
                  return (
                    <li className={getClassName(cookiebarClasses, 'cookiebarFormItemClassName', '')} key={cookie}>
                      {/* Bootstrap checkboxes */}
                      <FormControls.FormCheckInGroup
                        controlId={cookie}
                        label={
                          <>
                            {i18next.t(
                              cookie === 'functional-cookies'
                                ? 'cookies:cookiebarFunctional'
                                : cookie === 'analytical-cookies'
                                ? 'cookies:cookiebarAnalytical'
                                : cookie === 'video-cookies'
                                ? 'cookies:cookiebarVideos'
                                // : cookie === 'tracking-cookies'
                                : 'cookies:cookiebarTracking'
                                // : 'cookies:cookiebarReadspeaker'
                            )}
                            {'. '}
                            {i18next.t(
                              cookie === 'functional-cookies'
                                ? 'cookies:cookiebarFunctionalCookies'
                                : cookie === 'analytical-cookies'
                                ? 'cookies:cookiebarAnalyticalCookies'
                                : cookie === 'video-cookies'
                                ? 'cookies:cookiebarVideosCookies'
                                // : cookie === 'tracking-cookies'
                                : 'cookies:cookiebarTrackingCookies'
                                // : 'cookies:cookiebarReadspeakerCookies'
                            )}
                          </>
                        }
                        readOnly={requiredCookies.includes(cookie)}
                        required={requiredCookies.includes(cookie)}
                        checked={isAccepted === 'yes'}
                        validation={undefined}
                        onChange={(newValue) => {
                          onSetSingle(cookie, newValue ? 'yes' : 'no')
                        }}
                      />
                    </li>
                  )
                })}
              </ul>

              <button
                className={getClassName(cookiebarClasses, 'cookiebarClickablePrimaryClassName', 'btn btn-dark')}
                onClick={onApplySettings}
              >
                <span className={getClassName(cookiebarClasses, 'cookiebarClickableLabelClassName', '')}>
                  {i18next.t('cookies:cookiebarChangeSettings')}
                </span>
                {/* {SVGIcon && (
                  <svg
                    className={getClassName(
                      options,
                      'cookiebarClickableIconClassName',
                      'ml-3'
                    )}
                    aria-hidden="true"
                    width={SVGIcon.width ? SVGIcon.width : '24px'}
                    height={SVGIcon.height ? SVGIcon.height : '24px'}
                  >
                    <use
                      xlinkHref={getClassName(
                        options,
                        'iconId',
                        '#icon--chevron-right-large'
                      )}
                    />
                  </svg>
                )} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
